import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EUserStatus } from '../../types/newReview/userStatus';

export enum EUserStatusActionTypes {
  SetUserStatus = 'NEW_REVIEW/USER_STATUS/SET',
}

export type TSetUserStatusRatingType = ITypedReduxAction<EUserStatusActionTypes.SetUserStatus, EUserStatus>;

/**
 * Redux action, который записывает в store информацию о статусе пользователя нового отзыва
 * @param userStatus EUserStatus
 */
export const setUserStatus: (userStatus: EUserStatus) => TSetUserStatusRatingType = actionGenerator<
  EUserStatusActionTypes.SetUserStatus,
  EUserStatus
>(EUserStatusActionTypes.SetUserStatus);

export type TSetUserStatusRating = TSetUserStatusRatingType;
